<template>
  <div v-bind="$attrs" v-on="$listeners" />
</template>

<script>
  // light 版本仅支持 svg 渲染器，体积更小
  import lottie from 'lottie-web/build/player/lottie_light'
  import Vue from 'vue'
  import { endsWith } from 'vtils'

  export default Vue.extend({
    inheritAttrs: false,

    props: {
      src: {
        type: [Object, String],
        required: true,
      },
      autoplay: {
        type: Boolean,
        default: true,
      },
      loop: {
        type: Boolean,
        default: true,
      },
      fit: {
        type: String,
        default: 'contain',
      },
    },

    data: () => ({
      lottie: null,
    }),

    async mounted() {
      const isJsonUrl =
        typeof this.src === 'string' &&
        endsWith(this.src.split('?')[0], '.json')
      const isJsonData = typeof this.src === 'object'
      const isJson = isJsonUrl || isJsonData
      if (isJson) {
        this.lottie = lottie.loadAnimation({
          container: this.$el,
          loop: this.loop,
          autoplay: this.autoplay,
          renderer: 'svg',
          [isJsonUrl ? 'path' : 'animationData']: this.src,
          rendererSettings: {
            preserveAspectRatio:
              this.fit === 'contain' ? 'xMidYMid meet' : 'xMidYMid slice',
          },
        })
        if (this.autoplay) {
          this.startProgress()
        }
      }
    },

    beforeDestroy() {
      if (this.lottie) {
        this.lottie.destroy()
        this.lottie = null
      }
    },

    methods: {
      startProgress() {
        this.clearProgress()
        if (!this.loop) {
          const duration = this.lottie.getDuration() * 1000
          this._progress =
            !this._progress || this._progress >= duration ? 0 : this._progress
          const emit = () => {
            this._progress += 60
            const progress = Math.min(this._progress / duration, 1)
            if (progress === 1) {
              this.clearProgress()
            }
            this.$emit('progress', progress)
          }
          this._timer = setInterval(emit, 60)
          emit()
        }
      },
      clearProgress() {
        clearInterval(this._timer)
      },
      play() {
        this.lottie?.play()
        this.startProgress()
      },
      pause() {
        this.clearProgress()
        this.lottie?.pause()
      },
      stop() {
        this.clearProgress()
        this.lottie?.stop()
      },
      replay() {
        this.clearProgress()
        this.play()
      },
    },
  })
</script>
